export default {
  GET: 'VOD.LIST.GET',
  GET_PUBLIC: 'VOD.LIST.GET_PUBLIC',
  GET_PAYMENT_INFO: 'VOD.LIST.GET_PAYMENT_INFO',
  CREATE: 'VOD.LIST.CREATE',
  UPDATE: 'VOD.LIST.UPDATE',
  CHECK_PUBLISH: 'VOD.LIST.CHECK_PUBLISH',
  PUBLISH: 'VOD.LIST.PUBLISH',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/events/types/list.js